import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Box, Button, Toolbar, Typography } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../components/AuthGate';
import { usePageTracking } from '../hooks/useAnalytics';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';
const APP_VERSION = process.env.REACT_APP_APP_VERSION || 'Development';
const RELEASE_DATE = process.env.REACT_APP_RELEASE_DATE || '';

/** Minimal chrome for the My Workshops page: logo, title, version, logout. No nav, search or admin drawer. */
export default function HubLayout() {
  const [logoOk, setLogoOk] = useState(true);
  const { user } = useAuth();
  usePageTracking(user?.username);
  return (
    <div className="App">
      <AppBar position="sticky" sx={{ backgroundColor: 'rgb(218,41,28)' }}>
        <Toolbar disableGutters sx={{ alignItems: 'stretch' }}>
          {logoOk && (
            <img
              src={`${API_BASE_URL}/logo`}
              alt="Logo"
              style={{ height: 56, padding: '4px 8px 4px 16px', objectFit: 'contain' }}
              onError={() => setLogoOk(false)}
            />
          )}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', pl: logoOk ? 0 : 2 }}>
            <Typography variant="h6" component="div" sx={{ color: 'white', lineHeight: 1.2 }}>
              TEC Workshops
            </Typography>
            <Typography variant="caption" sx={{ color: 'white' }}>
              {APP_VERSION} {RELEASE_DATE}
            </Typography>
          </Box>
          <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={() => { window.location.href = `${API_BASE_URL}/auth/logout`; }}
            sx={{ mr: 1 }}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>
      <Outlet />
    </div>
  );
}
